import http from "plugins/axios";

export default {
  //之前的获取用户列表
  // getUserList({
  //   page = 1,
  //   size = 25,
  //   queryType,
  //   queryValue,
  //   userStatus,
  //   userType,
  //   mark
  // }) {
  //   return http.get({
  //     url: `/ta/admin/trade/user/${page}/${size}`,
  //     data: {
  //       queryType,
  //       queryValue,
  //       userStatus,
  //       userType,
  //       mark
  //     }
  //   });
  // },
  //更新后的查询所有用户信息
  getUserList({
    page,
    size,
    channelUserId,
    startTime,
    endTime,
  }) {
    return http.get({
      url: `/ta/admin/channel/getChannelAllBalance?page=${page}&size=${size}&channelUserId=${channelUserId}&startTime=${startTime}&endTime=${endTime}`,
    });
  },
  getChannelRebateDetail(params) {

    // 过滤掉 undefined 的参数
    const filteredParams = {};
    Object.keys(params || {}).forEach(key => {
      if (params[key] !== undefined) filteredParams[key] = params[key];
    });
    console.log('params', filteredParams);
    // return Promise.resolve({
    //   code: 0,
    //   data: {
    //     list: [],
    //     totalCount: 0,
    //   },
    // });

    return http.get({
      url: '/ta/admin/channel/getChannelRebateDetail',
      data: params,
    });
  },
  // 添加备注
  addRemark({ channelId, userId, remarks }) {
    return http.post({
      url: `/channel/user/addRemark?channelId=${channelId}&remarks=${remarks}&userId=${userId}`
    })
  },

  //可交易开关
  allowTrade({ userId, type }) {
    return http.post({
      url: `/ta/admin/user/allowTrade?userId=${userId}&type=${type}`,
    });
  },
  //可划入开关
  allowTransfer({ userId, type }) {
    return http.post({
      url: `/ta/admin/user/allowTransfer?userId=${userId}&type=${type}`,
    });
  },
  //开关仓开关
  allowSwitchBin({ userId, type }) {
    return http.post({
      url: `/ta/admin/user/open-position-switch?userId=${userId}&type=${type}`,
    });
  },
  updateVolunteer({ id, status }) {
    return http.post({
      url: `/ta/admin/trade/user/updateStatus/${id}`,
      data: {
        userVolunteerStatus: status,
      },
      dataType: "form",
    });
  },
  updateBlocking({ id, status, content }) {
    return http.post({
      url: "/ta/admin/trade/user/updateUserStatus",
      data: {
        id,
        userStatus: status,
        content: content,
      },
      dataType: "form",
    });
  },
  cancelGoogle(data) {
    return http.post({
      url: "/ta/admin/user/delete/googleAuth",
      data,
      dataType: "form",
    });
  },
  coutryCode() {
    return http.get({
      url: "/ta/admin/tenant/countryCodeList",
    });
  },
  updatInfo(data) {
    return http.post({
      url: "/ta/admin/user/update/tel",
      data,
      dataType: "form",
    });
  },
  updateUserType(data) {
    return http.post({
      url: "/ta/admin/user/userType/update",
      data,
      dataType: "form",
    });
  },
  updateDividendStatus(data) {
    return http.post({
      url: "/ta/admin/user/dividend/status/update",
      data,
      dataType: "form",
    });
  },
  setNode(data) {
    return http.post({
      url: "/ta/admin/starplan/create/node",
      data,
      dataType: "form",
    });
  },
  resetPassword(data) {
    return http.post({
      url: "/ta/admin/user/password/reset",
      data,
      dataType: "form",
    });
  },
  updateMark(data) {
    return http.post({
      url: "/ta/admin/user/mark",
      data,
      dataType: "form",
    });
  },
};
